export function makePromiseFromObject(obj) {
  const keys = Object.keys(obj);
  const values = Object.values(obj);
  return Promise.all(values).then(resolved => {
    const res = {};
    for (let i = 0; i < keys.length; i += 1) {
      res[keys[i]] = resolved[i];
    }
    return res;
  });
}
